import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import ProductDetails from './ProductDetails';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, data, selectedItem, checkedOut, message, error, addedToCart,
    newWatchlist,
    loadingWatchlist,
    cart,
    canceled,
    detailsError,
  } = state.market;
  return {
    isLoading,
    data,
    selectedItem,
    checkedOut,
    message,
    error,
    addedToCart,
    newWatchlist,
    loadingWatchlist,
    cart,
    canceled,
    detailsError,
  };
}

const Styled = withStyles(styles)(ProductDetails);

export default connect(
  mapStateToProps,
)(Styled);
